import React from "react"

const Materiel = () => {
  return <div className="materiel" />
}

export default Materiel
